<div class="shadow-xs layout-sidebar shadow-sm border border-[var(--border-default)]">
    <ul class="layout-menu layout-menu-main">
        @for (item of model; track item; let i = $index) {
            @if (shouldDisplay(item)) {
                <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
            }
            @if (item.separator) {
                <li class="menu-separator"></li>
            }
        }
    </ul>

    <!-- Pinned to the foot of the sidebar, the way Settings sits in most
         admin panels: reachable from anywhere, never moving as the groups
         above it change per user type. -->
    @if (bottomModel.length) {
        <ul class="layout-menu layout-menu-bottom">
            @for (item of bottomModel; track item; let i = $index) {
                @if (shouldDisplay(item)) {
                    <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
                }
            }
        </ul>
    }
</div>
